import { spacing } from 'common/theme';
import { typographyScale, TypographyVariant } from 'common/theme';

export const MODE = {
  FLAT: 'flat',
  OUTLINED: 'outlined',
  FORM: 'form',
};

export const LAYOUT_DIRECTION = {
  RTL: {
    direction: 'rtl',
    textAlign: 'right',
  },
  LTR: {
    direction: 'ltr',
    textAlign: 'left',
  },
};

export const DEFAULT_LAYOUT = LAYOUT_DIRECTION.RTL;

export const LABEL_CONFIG = {
  [MODE.FLAT]: {
    default: {
      top: 14,
      fontSize: typographyScale[TypographyVariant.BodyLarge].fontSize,
      placeholderRight: spacing.xs,
      shouldShow: true,
    },
    focused: {
      top: spacing.none,
      fontSize: typographyScale[TypographyVariant.BodySmall].fontSize,
      placeholderRight: spacing.xs,
      shouldShow: true,
    },
  },
  [MODE.OUTLINED]: {
    default: {
      top: 14,
      fontSize: typographyScale[TypographyVariant.BodyLarge].fontSize,
      placeholderRight: spacing.md,
      shouldShow: true,
    },
    focused: {
      top: -spacing.md,
      fontSize: typographyScale[TypographyVariant.BodySmall].fontSize,
      placeholderRight: spacing.md,
      shouldShow: true,
    },
  },
  [MODE.FORM]: {
    default: {
      top: spacing.none,
      fontSize: typographyScale[TypographyVariant.BodyMedium].fontSize,
      placeholderRight: spacing.none,
      shouldShow: true,
    },
    focused: {
      top: spacing.none,
      fontSize: typographyScale[TypographyVariant.BodyMedium].fontSize,
      placeholderRight: spacing.none,
      shouldShow: true,
    },
  },
};
